import { useQuery } from "@tanstack/react-query";
import { s3AdapterApi } from "@shared/api";

export function useFileMetadata({ fileId }: { fileId?: string }) {
  return useQuery({
    queryFn: () =>
      s3AdapterApi
        .post<
          Array<{
            fileNumber: number;
            fileId: string;
            fileName: string;
            fileType: string;
            fileContentLength: number;
            directory: string;
            md5Hash: string;
          }>
        >(`/files/meta`, [
          {
            fileNumber: 0,
            fileId,
          },
        ])
        .then((r) => r.data),
    queryKey: ["file", fileId, "meta"],
    enabled: !!fileId,
  });
}
